import React, { useCallback, useEffect, useMemo, useState } from "react"
import { CSSTransition } from "react-transition-group"
import i18nData from "@rogue_4/locales/zh-CN.json"
import { StyledComponent } from "@rogue_4/types"
import classNames from "classnames"

import { CommonTransition } from "@/topic/rogue_4/components/CommonTransition"
import { i18n } from "@/utils/i18n"
import GAME_RESULT_DICT from "../../../data/result"
import { useGameResult } from "../../../store"
import { SFX } from "../../../utils/sound"
import { getTransitionClassnames } from "../../../utils/transition"
import ModalList from "../common/modalList"
import ModalTitle from "../common/modalTitle"
import { useGameModalStore } from "../store"

import styles from "./index.module.less"

const GalleryModal: StyledComponent = ({ className, style }) => {
    const [active, setActive] = useState(false)
    const { resultUnlock, resultRead, readResult } = useGameResult()
    useEffect(() => {
        useGameModalStore.setState({
            callGalleryModal: () => {
                setActive(true)
            },
        })
    }, [])
    const [activeResult, rawSetActiveResult] = useState("01")
    const handleClose = useCallback(() => {
        SFX.play("commonClick")
        setActive(false)
        if (resultUnlock[activeResult]) {
            readResult(activeResult)
        }
    }, [activeResult, readResult, resultUnlock])
    const setActiveResult = useCallback(
        (value: string) => {
            rawSetActiveResult(value)
            if (resultUnlock[activeResult]) {
                readResult(activeResult)
            }
        },
        [readResult, resultUnlock, activeResult]
    )
    const result = useMemo(() => GAME_RESULT_DICT[activeResult], [activeResult])
    const descriptions = result?.description.split("\n")
    const unlock = resultUnlock[activeResult]
    return (
        <CSSTransition
            in={active}
            timeout={300}
            classNames={getTransitionClassnames(styles)}
        >
            <div
                className={classNames(styles.galleryModal, className)}
                style={style}
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <ModalTitle className={styles.title}>
                    {i18n(i18nData, "rogue_4.game.title.gallery")}
                </ModalTitle>
                <CommonTransition state={activeResult}>
                    {result ? (
                        <div
                            className={classNames(
                                styles.cg,
                                !unlock && styles.lock
                            )}
                        >
                            <div className={styles.image}>
                                <div
                                    className={styles.bg}
                                    style={{
                                        backgroundImage: unlock
                                            ? `url(${result.image})`
                                            : "linear-gradient(to right, rgba(20, 20, 20, 1) 0 , rgba(20, 20, 20, 1) 100%)",
                                    }}
                                ></div>
                            </div>
                            {!resultRead[result.key] && (
                                <div className={styles.new}></div>
                            )}
                            <div className={styles.label}>
                                <div
                                    className={classNames(
                                        styles.cn,
                                        unlock &&
                                            result.nameCn.length > 8 &&
                                            styles.small
                                    )}
                                >
                                    {unlock ? result.nameCn : "???"}
                                </div>
                                <div className={styles.en}>
                                    {unlock ? result.nameEn : "???"}
                                </div>
                            </div>
                            <div className={styles.content}>
                                {!unlock ? (
                                    <div
                                        className={styles.line}
                                        // style={{
                                        //     transform: "translateX(3rem)",
                                        // }}
                                    >
                                        <span>
                                            {i18n(
                                                i18nData,
                                                "rogue_4.game.gallery.lockNotice"
                                            )}
                                        </span>
                                    </div>
                                ) : (
                                    descriptions[0] && (
                                        <div className={styles.line}>
                                            <span>{descriptions?.[0]}</span>
                                        </div>
                                    )
                                )}
                                {unlock && descriptions[1] && (
                                    <div className={styles.line}>
                                        <span>{descriptions?.[1]}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                </CommonTransition>
                <ModalList
                    cur={activeResult}
                    className={styles.resultList}
                    list={Object.values(GAME_RESULT_DICT).map((r) => ({
                        key: r.key,
                        label: r.nameCn,
                        disabled: !resultUnlock[r.key],
                    }))}
                    onChange={setActiveResult}
                />
                <div className={styles.backButton} onClick={handleClose}></div>
            </div>
        </CSSTransition>
    )
}

export default GalleryModal
